import { Card } from "./ui/card";

// Card de resumo clicável compartilhado (delta 2026-09-16, referência
// visual fornecida) — extraído de Fichas.jsx para que Faturamento &
// Cobrança (e qualquer outra tela) use a MESMA linguagem visual, uma
// única implementação (nunca duas cópias que possam divergir). Compacto,
// ícone+título na mesma linha, número em destaque, percentual reservado
// na base do card (nunca uma seta de tendência inventada — só aparece
// quando `pct` vem de um cálculo real do chamador). Sem seta/chevron/
// lápis: a única indicação de interatividade é cursor pointer + hover/
// estado ativo discretos + foco de teclado visível.
export const SUMMARY_CARD_COLORS = {
  blue: {
    iconBg: "bg-blue-100", iconText: "text-blue-700", numberText: "text-blue-900",
    pctBg: "bg-blue-100", pctText: "text-blue-700", activeBorder: "border-blue-300",
    activeBg: "bg-blue-50/60", ring: "ring-blue-300", hoverBorder: "hover:border-blue-200",
  },
  emerald: {
    iconBg: "bg-emerald-100", iconText: "text-emerald-700", numberText: "text-emerald-900",
    pctBg: "bg-emerald-100", pctText: "text-emerald-700", activeBorder: "border-emerald-300",
    activeBg: "bg-emerald-50/60", ring: "ring-emerald-300", hoverBorder: "hover:border-emerald-200",
  },
  amber: {
    iconBg: "bg-amber-100", iconText: "text-amber-700", numberText: "text-amber-900",
    pctBg: "bg-amber-100", pctText: "text-amber-700", activeBorder: "border-amber-300",
    activeBg: "bg-amber-50/60", ring: "ring-amber-300", hoverBorder: "hover:border-amber-200",
  },
  red: {
    iconBg: "bg-red-100", iconText: "text-red-700", numberText: "text-red-900",
    pctBg: "bg-red-100", pctText: "text-red-700", activeBorder: "border-red-300",
    activeBg: "bg-red-50/60", ring: "ring-red-300", hoverBorder: "hover:border-red-200",
  },
  purple: {
    iconBg: "bg-purple-100", iconText: "text-purple-700", numberText: "text-purple-900",
    pctBg: "bg-purple-100", pctText: "text-purple-700", activeBorder: "border-purple-300",
    activeBg: "bg-purple-50/60", ring: "ring-purple-300", hoverBorder: "hover:border-purple-200",
  },
  indigo: {
    iconBg: "bg-indigo-100", iconText: "text-indigo-700", numberText: "text-indigo-900",
    pctBg: "bg-indigo-100", pctText: "text-indigo-700", activeBorder: "border-indigo-300",
    activeBg: "bg-indigo-50/60", ring: "ring-indigo-300", hoverBorder: "hover:border-indigo-200",
  },
};

export default function SummaryCard({ icon: Icon, label, value, pct, color, active, onClick, testId }) {
  const c = SUMMARY_CARD_COLORS[color];
  return (
    <Card
      className={`p-3.5 rounded-xl shadow-sm border cursor-pointer transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-1 focus-visible:ring-primary ${
        active ? `${c.activeBorder} ${c.activeBg} ring-2 ring-offset-1 ${c.ring} shadow-md` : `border-slate-200 ${c.hoverBorder} hover:shadow-md`
      }`}
      onClick={onClick}
      role="button"
      tabIndex={0}
      aria-pressed={active}
      aria-label={`Filtrar: ${label}`}
      data-testid={testId}
      onKeyDown={e => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); onClick(); } }}
    >
      <div className="flex items-center gap-2">
        <div className={`w-7 h-7 rounded-lg flex items-center justify-center shrink-0 ${c.iconBg} ${c.iconText}`}>
          <Icon size={15} />
        </div>
        <div className={`text-[11px] font-bold uppercase tracking-wide truncate ${c.iconText}`}>{label}</div>
      </div>
      <div className="mt-2 text-2xl font-heading font-bold text-slate-900">{value}</div>
      <div className="mt-1.5 min-h-[20px]">
        {pct != null && (
          <span className={`text-xs font-semibold rounded-full px-2 py-0.5 ${c.pctBg} ${c.pctText}`} data-testid={testId ? `${testId}-pct` : undefined}>{pct}%</span>
        )}
      </div>
    </Card>
  );
}
